module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-14.b03b9b93.svg";